<template>
  <a class="briefcase-coin-item" :href="link" target="_blank">
    <AvatarImage :size="20" :src="image" />
    <span class="briefcase-coin-item__name">{{ name }}</span>
    <span class="briefcase-coin-item__ticker">{{ ticker }}</span>
  </a>
</template>

<script setup>
  import { AvatarImage } from '@/Groups/Briefcase/private/imports/externalTemplates';
  //---------------------
  const props = defineProps({
    //Ссылка на картинку
    image: { type: String },
    //Имя монеты
    name: { type: String },
    //Тикер
    ticker: { type: String },
    //Ссылка на ресурс
    link: { type: String },
  });
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>
